import { Fragment, useState } from "react";
import { FormGroup, Input, Label } from "reactstrap";
import { Badges, Image, P } from "../../../../../AbstractElements";
import { useAppDispatch, useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { handleEnvelope, handleInterview } from "../../../../../ReduxToolkit/Reducers/LetterBoxSlice";
import { CommonDataType } from "../../../../../Types/LatterBoxType";
import { dynamicImage } from "../../../../../Utils";
import SvgIcon from "../../../../CommonComponents/SvgIcon/SvgIcon";

const EmailContent:React.FC<CommonDataType> = ({ data, ids }) => {
  const { faIcon } = useAppSelector((state) => state.letterBox);
  const [fill, setFill] = useState(false);
  const dispatch = useAppDispatch();

  return (
    <Fragment>
      <div className="inbox-user">
        <FormGroup check inline className="m-0">
          <Input className={`checkbox-primary`} name="emailCheckbox" id={`emailCheckbox${ids}`} type="checkbox" />
          <Label check for={`emailCheckbox${ids}`} />
        </FormGroup>
        <div onClick={() => setFill(!fill)}>
          <SvgIcon className={`important-mail ${fill ? "active" : ""}`} iconId="fill-star" />
        </div>
        <div className="rounded-border">
          {data.image && <Image src={dynamicImage(`${data.image}`)} alt="user" />}
          {data.shortName && (
            <div className={data.color === "success" ? "circle-success" : ""}>
              <P className={`font-${data.color}`}>{data.shortName}</P>
            </div>
          )}
        </div>
        <P>{data.name}</P>
      </div>
      <div className="inbox-message">
        <div className="email-data" onClick={() => dispatch(handleInterview(true))}>
          <span>
            {data.message}
            <span>{data.subMessage}</span>
          </span>
          <div className="inbox-width d-flex gap-2">
            {data.badge &&
              data.badge.map((item, i) => (
                <Badges color="" className={`m-0 badge-light-${item.color} font-${item.color === "light" ? "light-dark" : item.color}`} key={i}>
                  {item.title}
                </Badges>
              ))}
          </div>
        </div>
        <div className="email-timing">
          <span>{data.time}</span>
        </div>
        <div className="email-options">
          <i className={`fa fa-envelope-${!faIcon ? "o envelope-1" : "open-o envelope-2"}`} onClick={() => dispatch(handleEnvelope(!faIcon))} />
          <i className="fa fa-trash-o trash-3" />
          <i className="fa fa-print" />
        </div>
      </div>
    </Fragment>
  );
};

export default EmailContent;
